import { createSlice } from "@reduxjs/toolkit";
import { countryItems } from "../pages/Authentication/register/helpers/locationData";

const initialState = {
  name: "",
  surname: "",
  email: "",
  phone: "",
  password: "",
  passwordRetry: "",
  city: { id: "01", name: "İstanbul", code: 34 },
  country: countryItems.find(c => c.name === "Türkiye") || countryItems[0],
  interestedProducts: [],
  investmentAmount: {},
  address: "",
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    setRegisterInputs(state, action) {
      return { ...state, ...action.payload };
    },
    clearRegisterInputs(state) {
      return initialState;
    },
  },
});

export const { setRegisterInputs, clearRegisterInputs } = registerSlice.actions;
export default registerSlice.reducer;
